import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import {FORMAT, LOCALE} from '../../../providers/MomentProvider';

const MomentOverview = (props) => {
    return(<div>{Moment(props.moment).locale(LOCALE).format(FORMAT)}</div>);
};

MomentOverview.propTypes = {
    moment: PropTypes.instanceOf(Moment)
};

export default MomentOverview; 


// WEBPACK FOOTER //
// ./src/components/base/MomentOverview/MomentOverview.js